import { useMutation } from '@apollo/client'
import { ChangePassword as ChangePasswordMutation } from '../../types'
import { CHANGE_USER_PASSWORD } from './operations'

export const useChangePassword = () => useMutation<ChangePasswordMutation>(CHANGE_USER_PASSWORD)
